import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import moment from 'moment';

const ActivityTimeline = ({ limit = 10 }) => {
  const { getRecentActivities } = useNotifications();
  const activities = getRecentActivities(limit);

  const getActivityIcon = (type) => {
    const icons = {
      goal_update: '🎯',
      okr_reminder: '🚀',
      review_reminder: '📝',
      achievement: '🏆',
      feedback_received: '💬',
      team_update: '👥',
      real_time: '⚡',
      default: '📢'
    };
    return icons[type] || icons.default;
  };

  const getActivityColor = (type) => {
    const colors = {
      goal_update: 'bg-blue-100 text-blue-800',
      okr_reminder: 'bg-indigo-100 text-indigo-800',
      review_reminder: 'bg-yellow-100 text-yellow-800',
      achievement: 'bg-green-100 text-green-800',
      feedback_received: 'bg-purple-100 text-purple-800',
      team_update: 'bg-gray-100 text-gray-800',
      real_time: 'bg-pink-100 text-pink-800',
      default: 'bg-gray-100 text-gray-800'
    };
    return colors[type] || colors.default;
  };

  const formatTimeAgo = (timestamp) => {
    return moment(timestamp).fromNow();
  };

  if (activities.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Activity</h3>
        <div className="text-center py-8">
          <div className="text-gray-400 text-4xl mb-2">📋</div>
          <p className="text-gray-500">No recent activity to display</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Recent Activity</h3>
        <p className="text-sm text-gray-600">Stay updated with the latest changes</p>
      </div>
      
      <div className="p-6">
        <div className="flow-root">
          <ul className="-mb-8">
            {activities.map((activity, index) => (
              <li key={activity.id}>
                <div className="relative pb-8">
                  {index !== activities.length - 1 && (
                    <span
                      className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200"
                      aria-hidden="true"
                    />
                  )}
                  <div className="relative flex space-x-3">
                    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-white border-2 border-gray-300">
                      <span className="text-sm">{getActivityIcon(activity.type)}</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between">
                        <div className="flex-1">
                          <p className="text-sm font-medium text-gray-900">
                            {activity.title}
                          </p>
                          <p className="text-sm text-gray-600 mt-1">
                            {activity.description}
                          </p>
                        </div>
                        <div className="flex items-center space-x-2">
                          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getActivityColor(activity.type)}`}>
                            {activity.type.replace('_', ' ')}
                          </span>
                          <span className="text-xs text-gray-500 whitespace-nowrap">
                            {formatTimeAgo(activity.timestamp)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
        
        {activities.length >= limit && (
          <div className="mt-6 text-center">
            <button className="text-sm text-blue-600 hover:text-blue-800 font-medium">
              View all activities →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityTimeline;